import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Necesito cita previa?',
      answer: 'Sí, para garantizarte una atención exclusiva y sin esperas, trabajamos únicamente con cita previa. Puedes llamarnos al 643 218 449 o reservar a través de nuestro formulario.'
    },
    {
      question: '¿Dónde estáis exactamente?',
      answer: 'Nos encontramos en C. Gral. Castaños, 1, Getafe, Madrid. Es una zona tranquila con fácil acceso y aparcamiento cercano.'
    },
    {
      question: '¿Qué masajista me atenderá?',
      answer: 'Contamos con profesionales altamente cualificados como Tania, mencionada por nuestros clientes por sus "manos de oro" y profundo conocimiento de la anatomía.'
    },
    {
      question: '¿Cuánto dura una sesión de masaje?',
      answer: 'Las sesiones tienen una duración de 60 minutos, tiempo ideal para trabajar las zonas de tensión y lograr resultados efectivos. También ofrecemos sesiones de 90 minutos para tratamientos más completos.'
    },
    {
      question: '¿Qué tipo de masaje es mejor para mí?',
      answer: 'Depende de tus necesidades. Si tienes tensiones musculares y contracturas, el masaje descontracturante es ideal. Si buscas relajación y reducir el estrés, el masaje relajante es perfecto. Para deportistas, recomendamos el masaje deportivo. En tu primera visita, evaluaremos tu situación y te recomendaremos el tratamiento más adecuado.'
    },
    {
      question: '¿Cuál es el precio de los masajes?',
      answer: 'Nuestros precios son muy razonables y competitivos. Te invitamos a llamarnos al 643 218 449 para conocer nuestras tarifas actuales y promociones disponibles.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-[#F5F1E8]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-5xl font-medium text-[#2C3E2F] mb-4">
            Preguntas Frecuentes
          </h2>
          <div className="w-20 h-1 bg-[#A8B5A0] mx-auto mb-4"></div>
          <p className="text-lg text-gray-600">
            Resolvemos tus dudas antes de que aparezcan
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="font-sans font-semibold text-lg text-[#2C3E2F] pr-4">
                  {faq.question}
                </h3>
                <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-2xl text-[#A8B5A0]"></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            ¿Tienes más preguntas? Estamos aquí para ayudarte
          </p>
          <a
            href="tel:643218449"
            className="inline-flex items-center px-8 py-3 bg-[#2C3E2F] text-white rounded-full hover:bg-[#3d5442] transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Llámanos al 643 218 449
          </a>
        </div>
      </div>
    </section>
  );
}
